import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroManutencaoVeiculo from '../../actions/manutencao-veiculo/adicionarFiltroManutencaoVeiculo'
import removerFiltroManutencaoVeiculo from '../../actions/manutencao-veiculo/removerFiltroManutencaoVeiculo'
import {
    FILTRO_MANUTENCAO_VEICULO_USUARIO,
    FILTRO_TIPO_OCORRENCIA_MANUTENCAO_VEICULO,
    FILTRO_DATA_ENTRADA_MANUTENCAO_VEICULO,
    FILTRO_DATA_OCORRENCIA_MANUTENCAO_VEICULO
} from '../../util/filtros'
import FiltroBuscaManutencaoVeiculo from './FiltroBuscaManutencaoVeiculo'

export class FiltroManutencaoVeiculo extends Component {

    render() {
        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaManutencaoVeiculo 
                        filtro={FILTRO_MANUTENCAO_VEICULO_USUARIO}
                        opcoes={[]}
                        isNome={true}
                    />
                    <FiltroBuscaManutencaoVeiculo 
                        filtro={FILTRO_TIPO_OCORRENCIA_MANUTENCAO_VEICULO}
                        opcoes={[]}
                        isNome={true}
                    />
                    <FiltroBuscaManutencaoVeiculo
                        filtro={FILTRO_DATA_ENTRADA_MANUTENCAO_VEICULO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />
                    <FiltroBuscaManutencaoVeiculo
                        filtro={FILTRO_DATA_OCORRENCIA_MANUTENCAO_VEICULO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = (state) => ({    
    empresaSelecionada: state.empresaSelecionada,
    filtrosAdicionados: state.filtrosAdicionadosManutencaoVeiculo
  
  })
  
  export const mapDispatchToProps = dispatch => (
    bindActionCreators({
      adicionarFiltroManutencaoVeiculo,
      removerFiltroManutencaoVeiculo    
    }, dispatch)
  )
  
  export default connect(mapStateToProps, mapDispatchToProps)(FiltroManutencaoVeiculo)